import { Header, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import NewChatButton from "@/components/layout/NewChatButton";
import UserAnalytics from "@/components/user-analytics/UserAnalytics";

const AdminUserAnalyticsPage: React.FC = () => (
  <SpaceBetween size="xl">
    <Header
      variant="h1"
      description="How much the assistant is being used, by whom, with which models, and at what estimated cost. Figures start from when usage tracking was deployed; earlier activity was not recorded."
      actions={<NewChatButton />}
    >
      User Analytics
    </Header>
    <UserAnalytics />
  </SpaceBetween>
);

export default AdminUserAnalyticsPage;
